// extracted by mini-css-extract-plugin
export var bar = "layout-module--bar--a74b2";
export var brand = "layout-module--brand--f7bd3";
export var claim = "layout-module--claim--8c3cb";
export var footer = "layout-module--footer--95c70";
export var header = "layout-module--header--6a868";
export var main = "layout-module--main--6b2f2";
export var nav = "layout-module--nav--dad1f";
export var page = "layout-module--page--721d9";
export var skip = "layout-module--skip--f3c07";